<overlay-header [showCloseButton]="true" (closeClick)="closeClick('close')"></overlay-header>
<div class="flex-header">
  <student-header [disableNavigation]="true">
  </student-header>
</div>
<div style="position: absolute; left: 40%; right: 1%; top: 60px;">
  <table id="tblAllStandardsByStudent" style="width:100%;">
    <tr style="width:100%;">
      <td style="width:0%">
        <table style="margin-bottom: 5px; width: 60%; float: right; margin-top: 10px;">
          <tr>
            <td style="display:inline-block; padding-right:2px; padding-bottom: 3px;">
              <button (click)="firstObject()"
                [disabled]="(objectIndex == undefined || objectIndex < 1 || disableNavigationButton === true) == true"
                class="mat-nav-button navigationButton" mat-stroked-button>
                <span>
                  &lt;&lt;
                </span>
              </button>
            </td>
            <td style="display:inline-block; padding-right:5px; padding-bottom: 3px;">
              <button (click)="previousObject()"
                [disabled]="(objectIndex == undefined || objectIndex < 1 || disableNavigationButton === true) == true"
                class="mat-nav-button navigationButton" mat-stroked-button>
                <span>
                  &lt;
                </span>
              </button>
            </td>
            <td
              style="display:inline-block; margin-top:-13px; margin-bottom:-13px; position:relative; bottom:-2px;width: 65%">
              <tyl-form-field style="width:100%">
                <mat-select name="courseObjective" id="courseObjective" [compareWith]="compareObjects"
                  [(ngModel)]="studentCollectionTemplateVersionId" (ngModelChange)="dropDownChange(true)">
                  <mat-option *ngFor="let objective of ddData" [value]="objective.StudentCollectionTemplateVersionId">
                    {{objective.TemplateName}}
                  </mat-option>
                </mat-select>
              </tyl-form-field>
            </td>
            <td style="display:inline-block; padding-left:5px; padding-bottom: 3px;">
              <button (click)="nextObject()"
                [disabled]="(objectIndex != undefined && objectIndex == ddData.length - 1  || disableNavigationButton === true) == true"
                class="mat-nav-button navigationButton" mat-stroked-button>
                <span>
                  &gt;
                </span>
              </button>
            </td>
            <td style="display:inline-block; padding-left:2px; padding-bottom: 3px;">
              <button (click)="lastObject()"
                [disabled]="(objectIndex != undefined && objectIndex == ddData.length - 1 || disableNavigationButton === true) == true"
                class="mat-nav-button navigationButton" mat-stroked-button>
                <span>
                  &gt;&gt;
                </span>
              </button>
            </td>
          </tr>
        </table>
      </td>
    </tr>
  </table>
</div>
<div style="position: absolute; right: 4%; top: 130px;">
  <span [ngStyle]="{cursor: iconAllowed == true ? 'pointer' : 'text'}" *ngIf="!canEditForm" (click)="clickedOnLock()"
    style="background-color: #ffff99; width: 100px; height: 35px; padding: 5px; margin-right: 10px;  border: 2px solid; border-radius: 4px; line-height: 16px;"
    class="ng-star-inserted"><img src="./assets/images/lock.png"> View-only</span>
  <span *ngIf="canEditForm" (click)="clickedOnLock()"
    style="cursor: pointer; background-color: #ffff99; width: 100px; height: 35px; padding: 5px; margin-right: 10px;  border: 2px solid; border-radius: 4px; line-height: 16px;"
    class="ng-star-inserted"><img src="./assets/images/unlockednocircle.png"> Edit Mode</span>
</div>
<mat-dialog-content style="height: 100%; width: 100%;">
  <iframe #iframe id="ifrPDFViewer" style="height: 100%; width: 100%;" [src]="formSrc"></iframe>
</mat-dialog-content>
<mat-dialog-actions>
  <div class="flex-footer">
    <div class="flex-footer-left">
      <tyl-button *ngIf="canEditForm" id="printPreview" image="preview.png" label="Print Preview"
        (clickEvent)="saveClick(false, false, true)">
      </tyl-button>
    </div>
    <div class="flex-footer-right">
      <tyl-button *ngIf="canEditForm" id="saveButton" (clickEvent)="saveClick(undefined, true, false,false,true)"
        image="save.png" label="Save"></tyl-button>
      <tyl-button *ngIf="canEditForm" id="saveButton" (clickEvent)="saveClick(undefined,false,false,false,true)"
        image="save.png" label="Save and Close">
      </tyl-button>
      <tyl-button id="cancelButton" image="cancel.png" label="Cancel" (clickEvent)="closeClick('cancel')"></tyl-button>
    </div>
  </div>
</mat-dialog-actions>